import { NgModule } from '@angular/core'

import { MaterialModule } from '@shared/material/material.module'
import { WidgetsModule } from '@shared/widgets/widgets.module'
import { DialogsModule } from '@shared/dialogs/dialogs.module'
import { CommonComponentsModule } from '@shared/common-components/common-components.module'

import { PipesModule } from '@shared/pipes/pipes.module'
import { VendorModule } from '@shared/vendor.module'
import { ComponentsModule } from './components/components.module'
import { DirectiveModule } from './directives/directive.module'

@NgModule({
  declarations: [],
  exports: [
    CommonComponentsModule,
    DirectiveModule,
    DialogsModule,
    MaterialModule,
    PipesModule,
    WidgetsModule,
    VendorModule,
    ComponentsModule,
  ],
  imports: [DialogsModule, DirectiveModule, VendorModule, ComponentsModule],
  providers: [],
})
export class SharedModule {}
